/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type ActionReorderRequest,
    ActionReorderRequestFromJSON,
    ActionReorderRequestToJSON,
} from '../models/ActionReorderRequest';
import {
    type ActionReorderResponse,
    ActionReorderResponseFromJSON,
    ActionReorderResponseToJSON,
} from '../models/ActionReorderResponse';
import {
    type ActionRuleWrite,
    ActionRuleWriteFromJSON,
    ActionRuleWriteToJSON,
} from '../models/ActionRuleWrite';
import {
    type ActionRuleWriteRequest,
    ActionRuleWriteRequestFromJSON,
    ActionRuleWriteRequestToJSON,
} from '../models/ActionRuleWriteRequest';
import {
    type ConditionDetachResponse,
    ConditionDetachResponseFromJSON,
    ConditionDetachResponseToJSON,
} from '../models/ConditionDetachResponse';
import {
    type ConditionTreeResponse,
    ConditionTreeResponseFromJSON,
    ConditionTreeResponseToJSON,
} from '../models/ConditionTreeResponse';
import {
    type ConditionTreeWriteRequest,
    ConditionTreeWriteRequestFromJSON,
    ConditionTreeWriteRequestToJSON,
} from '../models/ConditionTreeWriteRequest';
import {
    type ConditionWrite,
    ConditionWriteFromJSON,
    ConditionWriteToJSON,
} from '../models/ConditionWrite';
import {
    type ConditionWriteRequest,
    ConditionWriteRequestFromJSON,
    ConditionWriteRequestToJSON,
} from '../models/ConditionWriteRequest';
import {
    type DryRunRequest,
    DryRunRequestFromJSON,
    DryRunRequestToJSON,
} from '../models/DryRunRequest';
import {
    type DryRunResponse,
    DryRunResponseFromJSON,
    DryRunResponseToJSON,
} from '../models/DryRunResponse';
import {
    type EditorMetadata,
    EditorMetadataFromJSON,
    EditorMetadataToJSON,
} from '../models/EditorMetadata';
import {
    type LinkingRule,
    LinkingRuleFromJSON,
    LinkingRuleToJSON,
} from '../models/LinkingRule';
import {
    type LinkingRuleRequest,
    LinkingRuleRequestFromJSON,
    LinkingRuleRequestToJSON,
} from '../models/LinkingRuleRequest';
import {
    type PaginatedWorkflowDefListList,
    PaginatedWorkflowDefListListFromJSON,
    PaginatedWorkflowDefListListToJSON,
} from '../models/PaginatedWorkflowDefListList';
import {
    type PatchedActionRuleWriteRequest,
    PatchedActionRuleWriteRequestFromJSON,
    PatchedActionRuleWriteRequestToJSON,
} from '../models/PatchedActionRuleWriteRequest';
import {
    type PatchedConditionWriteRequest,
    PatchedConditionWriteRequestFromJSON,
    PatchedConditionWriteRequestToJSON,
} from '../models/PatchedConditionWriteRequest';
import {
    type PatchedLinkingRuleRequest,
    PatchedLinkingRuleRequestFromJSON,
    PatchedLinkingRuleRequestToJSON,
} from '../models/PatchedLinkingRuleRequest';
import {
    type PatchedTransitionActionWriteRequest,
    PatchedTransitionActionWriteRequestFromJSON,
    PatchedTransitionActionWriteRequestToJSON,
} from '../models/PatchedTransitionActionWriteRequest';
import {
    type PatchedTransitionWriteRequest,
    PatchedTransitionWriteRequestFromJSON,
    PatchedTransitionWriteRequestToJSON,
} from '../models/PatchedTransitionWriteRequest';
import {
    type PatchedWorkflowDefWriteRequest,
    PatchedWorkflowDefWriteRequestFromJSON,
    PatchedWorkflowDefWriteRequestToJSON,
} from '../models/PatchedWorkflowDefWriteRequest';
import {
    type RuleReorderRequest,
    RuleReorderRequestFromJSON,
    RuleReorderRequestToJSON,
} from '../models/RuleReorderRequest';
import {
    type RuleReorderResponse,
    RuleReorderResponseFromJSON,
    RuleReorderResponseToJSON,
} from '../models/RuleReorderResponse';
import {
    type TransitionActionWrite,
    TransitionActionWriteFromJSON,
    TransitionActionWriteToJSON,
} from '../models/TransitionActionWrite';
import {
    type TransitionActionWriteRequest,
    TransitionActionWriteRequestFromJSON,
    TransitionActionWriteRequestToJSON,
} from '../models/TransitionActionWriteRequest';
import {
    type TransitionWrite,
    TransitionWriteFromJSON,
    TransitionWriteToJSON,
} from '../models/TransitionWrite';
import {
    type TransitionWriteRequest,
    TransitionWriteRequestFromJSON,
    TransitionWriteRequestToJSON,
} from '../models/TransitionWriteRequest';
import {
    type WorkflowDefCreate,
    WorkflowDefCreateFromJSON,
    WorkflowDefCreateToJSON,
} from '../models/WorkflowDefCreate';
import {
    type WorkflowDefCreateRequest,
    WorkflowDefCreateRequestFromJSON,
    WorkflowDefCreateRequestToJSON,
} from '../models/WorkflowDefCreateRequest';
import {
    type WorkflowDefEditor,
    WorkflowDefEditorFromJSON,
    WorkflowDefEditorToJSON,
} from '../models/WorkflowDefEditor';
import {
    type WorkflowDefWrite,
    WorkflowDefWriteFromJSON,
    WorkflowDefWriteToJSON,
} from '../models/WorkflowDefWrite';

export interface AdminWorkflowActionRulesCreateRequest {
    actionRuleWriteRequest: ActionRuleWriteRequest;
}

export interface AdminWorkflowActionRulesDestroyRequest {
    id: string;
}

export interface AdminWorkflowActionRulesListRequest {
    ordering?: string;
}

export interface AdminWorkflowActionRulesPartialUpdateRequest {
    id: string;
    patchedActionRuleWriteRequest?: PatchedActionRuleWriteRequest;
}

export interface AdminWorkflowActionRulesReorderCreateRequest {
    ruleReorderRequest: RuleReorderRequest;
}

export interface AdminWorkflowActionRulesRetrieveRequest {
    id: string;
}

export interface AdminWorkflowActionRulesUpdateRequest {
    id: string;
    actionRuleWriteRequest: ActionRuleWriteRequest;
}

export interface AdminWorkflowConditionsCreateRequest {
    conditionWriteRequest: ConditionWriteRequest;
}

export interface AdminWorkflowConditionsDestroyRequest {
    id: string;
}

export interface AdminWorkflowConditionsDetachCreateRequest {
    id: string;
}

export interface AdminWorkflowConditionsListRequest {
    ordering?: string;
}

export interface AdminWorkflowConditionsPartialUpdateRequest {
    id: string;
    patchedConditionWriteRequest?: PatchedConditionWriteRequest;
}

export interface AdminWorkflowConditionsRetrieveRequest {
    id: string;
}

export interface AdminWorkflowConditionsTreeUpdateRequest {
    id: string;
    conditionTreeWriteRequest: ConditionTreeWriteRequest;
}

export interface AdminWorkflowConditionsUpdateRequest {
    id: string;
    conditionWriteRequest: ConditionWriteRequest;
}

export interface AdminWorkflowDefinitionsCreateRequest {
    workflowDefCreateRequest: WorkflowDefCreateRequest;
}

export interface AdminWorkflowDefinitionsDryRunCreateRequest {
    id: string;
    dryRunRequest: DryRunRequest;
}

export interface AdminWorkflowDefinitionsListRequest {
    ordering?: string;
    page?: number;
    pageSize?: number;
}

export interface AdminWorkflowDefinitionsMetadataRetrieveRequest {
    id: string;
}

export interface AdminWorkflowDefinitionsPartialUpdateRequest {
    id: string;
    patchedWorkflowDefWriteRequest?: PatchedWorkflowDefWriteRequest;
}

export interface AdminWorkflowDefinitionsRetrieveRequest {
    id: string;
}

export interface AdminWorkflowLinkingRulesCreateRequest {
    linkingRuleRequest: LinkingRuleRequest;
}

export interface AdminWorkflowLinkingRulesDestroyRequest {
    id: number;
}

export interface AdminWorkflowLinkingRulesListRequest {
    ordering?: string;
}

export interface AdminWorkflowLinkingRulesPartialUpdateRequest {
    id: number;
    patchedLinkingRuleRequest?: PatchedLinkingRuleRequest;
}

export interface AdminWorkflowLinkingRulesRetrieveRequest {
    id: number;
}

export interface AdminWorkflowLinkingRulesUpdateRequest {
    id: number;
    linkingRuleRequest: LinkingRuleRequest;
}

export interface AdminWorkflowTransitionActionsCreateRequest {
    transitionActionWriteRequest: TransitionActionWriteRequest;
}

export interface AdminWorkflowTransitionActionsDestroyRequest {
    id: string;
}

export interface AdminWorkflowTransitionActionsListRequest {
    ordering?: string;
}

export interface AdminWorkflowTransitionActionsPartialUpdateRequest {
    id: string;
    patchedTransitionActionWriteRequest?: PatchedTransitionActionWriteRequest;
}

export interface AdminWorkflowTransitionActionsReorderCreateRequest {
    actionReorderRequest: ActionReorderRequest;
}

export interface AdminWorkflowTransitionActionsRetrieveRequest {
    id: string;
}

export interface AdminWorkflowTransitionActionsUpdateRequest {
    id: string;
    transitionActionWriteRequest: TransitionActionWriteRequest;
}

export interface AdminWorkflowTransitionsCreateRequest {
    transitionWriteRequest: TransitionWriteRequest;
}

export interface AdminWorkflowTransitionsDestroyRequest {
    id: string;
}

export interface AdminWorkflowTransitionsListRequest {
    ordering?: string;
}

export interface AdminWorkflowTransitionsPartialUpdateRequest {
    id: string;
    patchedTransitionWriteRequest?: PatchedTransitionWriteRequest;
}

export interface AdminWorkflowTransitionsRetrieveRequest {
    id: string;
}

export interface AdminWorkflowTransitionsUpdateRequest {
    id: string;
    transitionWriteRequest: TransitionWriteRequest;
}

/**
 * 
 */
export class WorkflowsApi extends runtime.BaseAPI {

    /**
     * Creates request options for adminWorkflowActionRulesCreate without sending the request
     */
    async adminWorkflowActionRulesCreateRequestOpts(requestParameters: AdminWorkflowActionRulesCreateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['actionRuleWriteRequest'] == null) {
            throw new runtime.RequiredError(
                'actionRuleWriteRequest',
                'Required parameter "actionRuleWriteRequest" was null or undefined when calling adminWorkflowActionRulesCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/admin/workflow-action-rules/`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ActionRuleWriteRequestToJSON(requestParameters['actionRuleWriteRequest']),
        };
    }

    /**
     * Rules of a configured action.
     */
    async adminWorkflowActionRulesCreateRaw(requestParameters: AdminWorkflowActionRulesCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ActionRuleWrite>> {
        const requestOptions = await this.adminWorkflowActionRulesCreateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ActionRuleWriteFromJSON(jsonValue));
    }

    /**
     * Rules of a configured action.
     */
    async adminWorkflowActionRulesCreate(requestParameters: AdminWorkflowActionRulesCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ActionRuleWrite> {
        const response = await this.adminWorkflowActionRulesCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminWorkflowActionRulesDestroy without sending the request
     */
    async adminWorkflowActionRulesDestroyRequestOpts(requestParameters: AdminWorkflowActionRulesDestroyRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminWorkflowActionRulesDestroy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/admin/workflow-action-rules/{id}/`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Rules of a configured action.
     */
    async adminWorkflowActionRulesDestroyRaw(requestParameters: AdminWorkflowActionRulesDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.adminWorkflowActionRulesDestroyRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Rules of a configured action.
     */
    async adminWorkflowActionRulesDestroy(requestParameters: AdminWorkflowActionRulesDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.adminWorkflowActionRulesDestroyRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for adminWorkflowActionRulesList without sending the request
     */
    async adminWorkflowActionRulesListRequestOpts(requestParameters: AdminWorkflowActionRulesListRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/admin/workflow-action-rules/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Rules of a configured action.
     */
    async adminWorkflowActionRulesListRaw(requestParameters: AdminWorkflowActionRulesListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ActionRuleWrite>>> {
        const requestOptions = await this.adminWorkflowActionRulesListRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ActionRuleWriteFromJSON));
    }

    /**
     * Rules of a configured action.
     */
    async adminWorkflowActionRulesList(requestParameters: AdminWorkflowActionRulesListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ActionRuleWrite>> {
        const response = await this.adminWorkflowActionRulesListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminWorkflowActionRulesPartialUpdate without sending the request
     */
    async adminWorkflowActionRulesPartialUpdateRequestOpts(requestParameters: AdminWorkflowActionRulesPartialUpdateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminWorkflowActionRulesPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/admin/workflow-action-rules/{id}/`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedActionRuleWriteRequestToJSON(requestParameters['patchedActionRuleWriteRequest']),
        };
    }

    /**
     * Rules of a configured action.
     */
    async adminWorkflowActionRulesPartialUpdateRaw(requestParameters: AdminWorkflowActionRulesPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ActionRuleWrite>> {
        const requestOptions = await this.adminWorkflowActionRulesPartialUpdateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ActionRuleWriteFromJSON(jsonValue));
    }

    /**
     * Rules of a configured action.
     */
    async adminWorkflowActionRulesPartialUpdate(requestParameters: AdminWorkflowActionRulesPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ActionRuleWrite> {
        const response = await this.adminWorkflowActionRulesPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminWorkflowActionRulesReorderCreate without sending the request
     */
    async adminWorkflowActionRulesReorderCreateRequestOpts(requestParameters: AdminWorkflowActionRulesReorderCreateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['ruleReorderRequest'] == null) {
            throw new runtime.RequiredError(
                'ruleReorderRequest',
                'Required parameter "ruleReorderRequest" was null or undefined when calling adminWorkflowActionRulesReorderCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/admin/workflow-action-rules/reorder/`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RuleReorderRequestToJSON(requestParameters['ruleReorderRequest']),
        };
    }

    /**
     * Assign positions 0..n-1 from the submitted order, in one transaction.  Replaces the client sequencing three PATCHes through a parking position to dodge the uniqueness rule. The constraint is DEFERRABLE, so the intermediate collisions inside this transaction are legal and only the committed state is checked.
     */
    async adminWorkflowActionRulesReorderCreateRaw(requestParameters: AdminWorkflowActionRulesReorderCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RuleReorderResponse>> {
        const requestOptions = await this.adminWorkflowActionRulesReorderCreateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RuleReorderResponseFromJSON(jsonValue));
    }

    /**
     * Assign positions 0..n-1 from the submitted order, in one transaction.  Replaces the client sequencing three PATCHes through a parking position to dodge the uniqueness rule. The constraint is DEFERRABLE, so the intermediate collisions inside this transaction are legal and only the committed state is checked.
     */
    async adminWorkflowActionRulesReorderCreate(requestParameters: AdminWorkflowActionRulesReorderCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RuleReorderResponse> {
        const response = await this.adminWorkflowActionRulesReorderCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminWorkflowActionRulesRetrieve without sending the request
     */
    async adminWorkflowActionRulesRetrieveRequestOpts(requestParameters: AdminWorkflowActionRulesRetrieveRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminWorkflowActionRulesRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/admin/workflow-action-rules/{id}/`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Rules of a configured action.
     */
    async adminWorkflowActionRulesRetrieveRaw(requestParameters: AdminWorkflowActionRulesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ActionRuleWrite>> {
        const requestOptions = await this.adminWorkflowActionRulesRetrieveRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ActionRuleWriteFromJSON(jsonValue));
    }

    /**
     * Rules of a configured action.
     */
    async adminWorkflowActionRulesRetrieve(requestParameters: AdminWorkflowActionRulesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ActionRuleWrite> {
        const response = await this.adminWorkflowActionRulesRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminWorkflowActionRulesUpdate without sending the request
     */
    async adminWorkflowActionRulesUpdateRequestOpts(requestParameters: AdminWorkflowActionRulesUpdateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminWorkflowActionRulesUpdate().'
            );
        }

        if (requestParameters['actionRuleWriteRequest'] == null) {
            throw new runtime.RequiredError(
                'actionRuleWriteRequest',
                'Required parameter "actionRuleWriteRequest" was null or undefined when calling adminWorkflowActionRulesUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/admin/workflow-action-rules/{id}/`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ActionRuleWriteRequestToJSON(requestParameters['actionRuleWriteRequest']),
        };
    }

    /**
     * Rules of a configured action.
     */
    async adminWorkflowActionRulesUpdateRaw(requestParameters: AdminWorkflowActionRulesUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ActionRuleWrite>> {
        const requestOptions = await this.adminWorkflowActionRulesUpdateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ActionRuleWriteFromJSON(jsonValue));
    }

    /**
     * Rules of a configured action.
     */
    async adminWorkflowActionRulesUpdate(requestParameters: AdminWorkflowActionRulesUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ActionRuleWrite> {
        const response = await this.adminWorkflowActionRulesUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminWorkflowConditionsCreate without sending the request
     */
    async adminWorkflowConditionsCreateRequestOpts(requestParameters: AdminWorkflowConditionsCreateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['conditionWriteRequest'] == null) {
            throw new runtime.RequiredError(
                'conditionWriteRequest',
                'Required parameter "conditionWriteRequest" was null or undefined when calling adminWorkflowConditionsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/admin/workflow-conditions/`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ConditionWriteRequestToJSON(requestParameters['conditionWriteRequest']),
        };
    }

    /**
     * Conditions, and the two operations their structure demands.  A condition\'s tree is replaced through ``tree``; detaching one from a rule goes through ``detach`` because ActionRule.condition cascades.
     */
    async adminWorkflowConditionsCreateRaw(requestParameters: AdminWorkflowConditionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ConditionWrite>> {
        const requestOptions = await this.adminWorkflowConditionsCreateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ConditionWriteFromJSON(jsonValue));
    }

    /**
     * Conditions, and the two operations their structure demands.  A condition\'s tree is replaced through ``tree``; detaching one from a rule goes through ``detach`` because ActionRule.condition cascades.
     */
    async adminWorkflowConditionsCreate(requestParameters: AdminWorkflowConditionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ConditionWrite> {
        const response = await this.adminWorkflowConditionsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminWorkflowConditionsDestroy without sending the request
     */
    async adminWorkflowConditionsDestroyRequestOpts(requestParameters: AdminWorkflowConditionsDestroyRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminWorkflowConditionsDestroy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/admin/workflow-conditions/{id}/`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Conditions, and the two operations their structure demands.  A condition\'s tree is replaced through ``tree``; detaching one from a rule goes through ``detach`` because ActionRule.condition cascades.
     */
    async adminWorkflowConditionsDestroyRaw(requestParameters: AdminWorkflowConditionsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.adminWorkflowConditionsDestroyRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Conditions, and the two operations their structure demands.  A condition\'s tree is replaced through ``tree``; detaching one from a rule goes through ``detach`` because ActionRule.condition cascades.
     */
    async adminWorkflowConditionsDestroy(requestParameters: AdminWorkflowConditionsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.adminWorkflowConditionsDestroyRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for adminWorkflowConditionsDetachCreate without sending the request
     */
    async adminWorkflowConditionsDetachCreateRequestOpts(requestParameters: AdminWorkflowConditionsDetachCreateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminWorkflowConditionsDetachCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/admin/workflow-conditions/{id}/detach/`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Detach the condition from whatever holds it, then delete it.  ActionRule.condition is CASCADE by design — nulling a rule\'s condition would silently promote it to an always-match rule that shadows every rule below it — so deleting a still-attached condition takes its rules with it. Clearing the references first, in the same transaction, is the only safe order, and it is not something a client should be left to sequence.
     */
    async adminWorkflowConditionsDetachCreateRaw(requestParameters: AdminWorkflowConditionsDetachCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ConditionDetachResponse>> {
        const requestOptions = await this.adminWorkflowConditionsDetachCreateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ConditionDetachResponseFromJSON(jsonValue));
    }

    /**
     * Detach the condition from whatever holds it, then delete it.  ActionRule.condition is CASCADE by design — nulling a rule\'s condition would silently promote it to an always-match rule that shadows every rule below it — so deleting a still-attached condition takes its rules with it. Clearing the references first, in the same transaction, is the only safe order, and it is not something a client should be left to sequence.
     */
    async adminWorkflowConditionsDetachCreate(requestParameters: AdminWorkflowConditionsDetachCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ConditionDetachResponse> {
        const response = await this.adminWorkflowConditionsDetachCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminWorkflowConditionsList without sending the request
     */
    async adminWorkflowConditionsListRequestOpts(requestParameters: AdminWorkflowConditionsListRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/admin/workflow-conditions/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Conditions, and the two operations their structure demands.  A condition\'s tree is replaced through ``tree``; detaching one from a rule goes through ``detach`` because ActionRule.condition cascades.
     */
    async adminWorkflowConditionsListRaw(requestParameters: AdminWorkflowConditionsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ConditionWrite>>> {
        const requestOptions = await this.adminWorkflowConditionsListRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ConditionWriteFromJSON));
    }

    /**
     * Conditions, and the two operations their structure demands.  A condition\'s tree is replaced through ``tree``; detaching one from a rule goes through ``detach`` because ActionRule.condition cascades.
     */
    async adminWorkflowConditionsList(requestParameters: AdminWorkflowConditionsListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ConditionWrite>> {
        const response = await this.adminWorkflowConditionsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminWorkflowConditionsPartialUpdate without sending the request
     */
    async adminWorkflowConditionsPartialUpdateRequestOpts(requestParameters: AdminWorkflowConditionsPartialUpdateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminWorkflowConditionsPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/admin/workflow-conditions/{id}/`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedConditionWriteRequestToJSON(requestParameters['patchedConditionWriteRequest']),
        };
    }

    /**
     * Conditions, and the two operations their structure demands.  A condition\'s tree is replaced through ``tree``; detaching one from a rule goes through ``detach`` because ActionRule.condition cascades.
     */
    async adminWorkflowConditionsPartialUpdateRaw(requestParameters: AdminWorkflowConditionsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ConditionWrite>> {
        const requestOptions = await this.adminWorkflowConditionsPartialUpdateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ConditionWriteFromJSON(jsonValue));
    }

    /**
     * Conditions, and the two operations their structure demands.  A condition\'s tree is replaced through ``tree``; detaching one from a rule goes through ``detach`` because ActionRule.condition cascades.
     */
    async adminWorkflowConditionsPartialUpdate(requestParameters: AdminWorkflowConditionsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ConditionWrite> {
        const response = await this.adminWorkflowConditionsPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminWorkflowConditionsRetrieve without sending the request
     */
    async adminWorkflowConditionsRetrieveRequestOpts(requestParameters: AdminWorkflowConditionsRetrieveRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminWorkflowConditionsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/admin/workflow-conditions/{id}/`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Conditions, and the two operations their structure demands.  A condition\'s tree is replaced through ``tree``; detaching one from a rule goes through ``detach`` because ActionRule.condition cascades.
     */
    async adminWorkflowConditionsRetrieveRaw(requestParameters: AdminWorkflowConditionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ConditionWrite>> {
        const requestOptions = await this.adminWorkflowConditionsRetrieveRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ConditionWriteFromJSON(jsonValue));
    }

    /**
     * Conditions, and the two operations their structure demands.  A condition\'s tree is replaced through ``tree``; detaching one from a rule goes through ``detach`` because ActionRule.condition cascades.
     */
    async adminWorkflowConditionsRetrieve(requestParameters: AdminWorkflowConditionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ConditionWrite> {
        const response = await this.adminWorkflowConditionsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminWorkflowConditionsTreeUpdate without sending the request
     */
    async adminWorkflowConditionsTreeUpdateRequestOpts(requestParameters: AdminWorkflowConditionsTreeUpdateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminWorkflowConditionsTreeUpdate().'
            );
        }

        if (requestParameters['conditionTreeWriteRequest'] == null) {
            throw new runtime.RequiredError(
                'conditionTreeWriteRequest',
                'Required parameter "conditionTreeWriteRequest" was null or undefined when calling adminWorkflowConditionsTreeUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/admin/workflow-conditions/{id}/tree/`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ConditionTreeWriteRequestToJSON(requestParameters['conditionTreeWriteRequest']),
        };
    }

    /**
     * Replace the condition\'s whole group and expression tree.  Atomic: the prototype deleted the old tree outside a transaction, so a payload that failed part-way left a condition with nothing in it.
     */
    async adminWorkflowConditionsTreeUpdateRaw(requestParameters: AdminWorkflowConditionsTreeUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ConditionTreeResponse>> {
        const requestOptions = await this.adminWorkflowConditionsTreeUpdateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ConditionTreeResponseFromJSON(jsonValue));
    }

    /**
     * Replace the condition\'s whole group and expression tree.  Atomic: the prototype deleted the old tree outside a transaction, so a payload that failed part-way left a condition with nothing in it.
     */
    async adminWorkflowConditionsTreeUpdate(requestParameters: AdminWorkflowConditionsTreeUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ConditionTreeResponse> {
        const response = await this.adminWorkflowConditionsTreeUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminWorkflowConditionsUpdate without sending the request
     */
    async adminWorkflowConditionsUpdateRequestOpts(requestParameters: AdminWorkflowConditionsUpdateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminWorkflowConditionsUpdate().'
            );
        }

        if (requestParameters['conditionWriteRequest'] == null) {
            throw new runtime.RequiredError(
                'conditionWriteRequest',
                'Required parameter "conditionWriteRequest" was null or undefined when calling adminWorkflowConditionsUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/admin/workflow-conditions/{id}/`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ConditionWriteRequestToJSON(requestParameters['conditionWriteRequest']),
        };
    }

    /**
     * Conditions, and the two operations their structure demands.  A condition\'s tree is replaced through ``tree``; detaching one from a rule goes through ``detach`` because ActionRule.condition cascades.
     */
    async adminWorkflowConditionsUpdateRaw(requestParameters: AdminWorkflowConditionsUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ConditionWrite>> {
        const requestOptions = await this.adminWorkflowConditionsUpdateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ConditionWriteFromJSON(jsonValue));
    }

    /**
     * Conditions, and the two operations their structure demands.  A condition\'s tree is replaced through ``tree``; detaching one from a rule goes through ``detach`` because ActionRule.condition cascades.
     */
    async adminWorkflowConditionsUpdate(requestParameters: AdminWorkflowConditionsUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ConditionWrite> {
        const response = await this.adminWorkflowConditionsUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminWorkflowDefinitionsCreate without sending the request
     */
    async adminWorkflowDefinitionsCreateRequestOpts(requestParameters: AdminWorkflowDefinitionsCreateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['workflowDefCreateRequest'] == null) {
            throw new runtime.RequiredError(
                'workflowDefCreateRequest',
                'Required parameter "workflowDefCreateRequest" was null or undefined when calling adminWorkflowDefinitionsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/admin/workflow-definitions/`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WorkflowDefCreateRequestToJSON(requestParameters['workflowDefCreateRequest']),
        };
    }

    /**
     * Create a definition, optionally owned by a company.  A new definition has no transitions, so it does nothing until one is added — which the validation overview says on the editor\'s first load.
     */
    async adminWorkflowDefinitionsCreateRaw(requestParameters: AdminWorkflowDefinitionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkflowDefCreate>> {
        const requestOptions = await this.adminWorkflowDefinitionsCreateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkflowDefCreateFromJSON(jsonValue));
    }

    /**
     * Create a definition, optionally owned by a company.  A new definition has no transitions, so it does nothing until one is added — which the validation overview says on the editor\'s first load.
     */
    async adminWorkflowDefinitionsCreate(requestParameters: AdminWorkflowDefinitionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkflowDefCreate> {
        const response = await this.adminWorkflowDefinitionsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminWorkflowDefinitionsDryRunCreate without sending the request
     */
    async adminWorkflowDefinitionsDryRunCreateRequestOpts(requestParameters: AdminWorkflowDefinitionsDryRunCreateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminWorkflowDefinitionsDryRunCreate().'
            );
        }

        if (requestParameters['dryRunRequest'] == null) {
            throw new runtime.RequiredError(
                'dryRunRequest',
                'Required parameter "dryRunRequest" was null or undefined when calling adminWorkflowDefinitionsDryRunCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/admin/workflow-definitions/{id}/dry_run/`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DryRunRequestToJSON(requestParameters['dryRunRequest']),
        };
    }

    /**
     * Evaluate this definition against a real event, without doing anything.  The single thing the Django admin cannot do at all, and the reason the graph is worth building: it answers \"which transition fires, and which rule wins\" before a configuration meets production data.  Mirrors the engine deliberately — ``ordered_by_status_and_priority``, first transition whose from_status matches and whose condition evaluates, then the first matching rule of each configured action. It reuses ConditionEvaluator rather than reimplementing evaluation, because a dry run that disagrees with the engine is worse than none.  Read-only: no action is called, nothing is saved, and the event\'s status is untouched.
     */
    async adminWorkflowDefinitionsDryRunCreateRaw(requestParameters: AdminWorkflowDefinitionsDryRunCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DryRunResponse>> {
        const requestOptions = await this.adminWorkflowDefinitionsDryRunCreateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DryRunResponseFromJSON(jsonValue));
    }

    /**
     * Evaluate this definition against a real event, without doing anything.  The single thing the Django admin cannot do at all, and the reason the graph is worth building: it answers \"which transition fires, and which rule wins\" before a configuration meets production data.  Mirrors the engine deliberately — ``ordered_by_status_and_priority``, first transition whose from_status matches and whose condition evaluates, then the first matching rule of each configured action. It reuses ConditionEvaluator rather than reimplementing evaluation, because a dry run that disagrees with the engine is worse than none.  Read-only: no action is called, nothing is saved, and the event\'s status is untouched.
     */
    async adminWorkflowDefinitionsDryRunCreate(requestParameters: AdminWorkflowDefinitionsDryRunCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DryRunResponse> {
        const response = await this.adminWorkflowDefinitionsDryRunCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminWorkflowDefinitionsList without sending the request
     */
    async adminWorkflowDefinitionsListRequestOpts(requestParameters: AdminWorkflowDefinitionsListRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/admin/workflow-definitions/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Every definition, as the editor\'s entry point.
     */
    async adminWorkflowDefinitionsListRaw(requestParameters: AdminWorkflowDefinitionsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedWorkflowDefListList>> {
        const requestOptions = await this.adminWorkflowDefinitionsListRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedWorkflowDefListListFromJSON(jsonValue));
    }

    /**
     * Every definition, as the editor\'s entry point.
     */
    async adminWorkflowDefinitionsList(requestParameters: AdminWorkflowDefinitionsListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedWorkflowDefListList> {
        const response = await this.adminWorkflowDefinitionsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminWorkflowDefinitionsMetadataRetrieve without sending the request
     */
    async adminWorkflowDefinitionsMetadataRetrieveRequestOpts(requestParameters: AdminWorkflowDefinitionsMetadataRetrieveRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminWorkflowDefinitionsMetadataRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/admin/workflow-definitions/{id}/metadata/`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Everything the editor needs to populate its controls, scoped to this definition.  Served rather than hardcoded client-side: the status list and their rank order, the operators legal per field type, and the actions this company may configure all live in Python and would otherwise be duplicated in TypeScript and drift.
     */
    async adminWorkflowDefinitionsMetadataRetrieveRaw(requestParameters: AdminWorkflowDefinitionsMetadataRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EditorMetadata>> {
        const requestOptions = await this.adminWorkflowDefinitionsMetadataRetrieveRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EditorMetadataFromJSON(jsonValue));
    }

    /**
     * Everything the editor needs to populate its controls, scoped to this definition.  Served rather than hardcoded client-side: the status list and their rank order, the operators legal per field type, and the actions this company may configure all live in Python and would otherwise be duplicated in TypeScript and drift.
     */
    async adminWorkflowDefinitionsMetadataRetrieve(requestParameters: AdminWorkflowDefinitionsMetadataRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EditorMetadata> {
        const response = await this.adminWorkflowDefinitionsMetadataRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminWorkflowDefinitionsPartialUpdate without sending the request
     */
    async adminWorkflowDefinitionsPartialUpdateRequestOpts(requestParameters: AdminWorkflowDefinitionsPartialUpdateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminWorkflowDefinitionsPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/admin/workflow-definitions/{id}/`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedWorkflowDefWriteRequestToJSON(requestParameters['patchedWorkflowDefWriteRequest']),
        };
    }

    /**
     * Edit the definition\'s own fields. Owner is not editable — see the write serializer.
     */
    async adminWorkflowDefinitionsPartialUpdateRaw(requestParameters: AdminWorkflowDefinitionsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkflowDefWrite>> {
        const requestOptions = await this.adminWorkflowDefinitionsPartialUpdateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkflowDefWriteFromJSON(jsonValue));
    }

    /**
     * Edit the definition\'s own fields. Owner is not editable — see the write serializer.
     */
    async adminWorkflowDefinitionsPartialUpdate(requestParameters: AdminWorkflowDefinitionsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkflowDefWrite> {
        const response = await this.adminWorkflowDefinitionsPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminWorkflowDefinitionsRetrieve without sending the request
     */
    async adminWorkflowDefinitionsRetrieveRequestOpts(requestParameters: AdminWorkflowDefinitionsRetrieveRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminWorkflowDefinitionsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/admin/workflow-definitions/{id}/`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * The whole definition, with transitions in engine evaluation order.
     */
    async adminWorkflowDefinitionsRetrieveRaw(requestParameters: AdminWorkflowDefinitionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkflowDefEditor>> {
        const requestOptions = await this.adminWorkflowDefinitionsRetrieveRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkflowDefEditorFromJSON(jsonValue));
    }

    /**
     * The whole definition, with transitions in engine evaluation order.
     */
    async adminWorkflowDefinitionsRetrieve(requestParameters: AdminWorkflowDefinitionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkflowDefEditor> {
        const response = await this.adminWorkflowDefinitionsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminWorkflowLinkingRulesCreate without sending the request
     */
    async adminWorkflowLinkingRulesCreateRequestOpts(requestParameters: AdminWorkflowLinkingRulesCreateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['linkingRuleRequest'] == null) {
            throw new runtime.RequiredError(
                'linkingRuleRequest',
                'Required parameter "linkingRuleRequest" was null or undefined when calling adminWorkflowLinkingRulesCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/admin/workflow-linking-rules/`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LinkingRuleRequestToJSON(requestParameters['linkingRuleRequest']),
        };
    }

    /**
     * Event linking configuration for a definition.
     */
    async adminWorkflowLinkingRulesCreateRaw(requestParameters: AdminWorkflowLinkingRulesCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LinkingRule>> {
        const requestOptions = await this.adminWorkflowLinkingRulesCreateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LinkingRuleFromJSON(jsonValue));
    }

    /**
     * Event linking configuration for a definition.
     */
    async adminWorkflowLinkingRulesCreate(requestParameters: AdminWorkflowLinkingRulesCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LinkingRule> {
        const response = await this.adminWorkflowLinkingRulesCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminWorkflowLinkingRulesDestroy without sending the request
     */
    async adminWorkflowLinkingRulesDestroyRequestOpts(requestParameters: AdminWorkflowLinkingRulesDestroyRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminWorkflowLinkingRulesDestroy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/admin/workflow-linking-rules/{id}/`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Event linking configuration for a definition.
     */
    async adminWorkflowLinkingRulesDestroyRaw(requestParameters: AdminWorkflowLinkingRulesDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.adminWorkflowLinkingRulesDestroyRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Event linking configuration for a definition.
     */
    async adminWorkflowLinkingRulesDestroy(requestParameters: AdminWorkflowLinkingRulesDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.adminWorkflowLinkingRulesDestroyRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for adminWorkflowLinkingRulesList without sending the request
     */
    async adminWorkflowLinkingRulesListRequestOpts(requestParameters: AdminWorkflowLinkingRulesListRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/admin/workflow-linking-rules/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Event linking configuration for a definition.
     */
    async adminWorkflowLinkingRulesListRaw(requestParameters: AdminWorkflowLinkingRulesListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<LinkingRule>>> {
        const requestOptions = await this.adminWorkflowLinkingRulesListRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(LinkingRuleFromJSON));
    }

    /**
     * Event linking configuration for a definition.
     */
    async adminWorkflowLinkingRulesList(requestParameters: AdminWorkflowLinkingRulesListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<LinkingRule>> {
        const response = await this.adminWorkflowLinkingRulesListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminWorkflowLinkingRulesPartialUpdate without sending the request
     */
    async adminWorkflowLinkingRulesPartialUpdateRequestOpts(requestParameters: AdminWorkflowLinkingRulesPartialUpdateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminWorkflowLinkingRulesPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/admin/workflow-linking-rules/{id}/`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedLinkingRuleRequestToJSON(requestParameters['patchedLinkingRuleRequest']),
        };
    }

    /**
     * Event linking configuration for a definition.
     */
    async adminWorkflowLinkingRulesPartialUpdateRaw(requestParameters: AdminWorkflowLinkingRulesPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LinkingRule>> {
        const requestOptions = await this.adminWorkflowLinkingRulesPartialUpdateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LinkingRuleFromJSON(jsonValue));
    }

    /**
     * Event linking configuration for a definition.
     */
    async adminWorkflowLinkingRulesPartialUpdate(requestParameters: AdminWorkflowLinkingRulesPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LinkingRule> {
        const response = await this.adminWorkflowLinkingRulesPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminWorkflowLinkingRulesRetrieve without sending the request
     */
    async adminWorkflowLinkingRulesRetrieveRequestOpts(requestParameters: AdminWorkflowLinkingRulesRetrieveRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminWorkflowLinkingRulesRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/admin/workflow-linking-rules/{id}/`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Event linking configuration for a definition.
     */
    async adminWorkflowLinkingRulesRetrieveRaw(requestParameters: AdminWorkflowLinkingRulesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LinkingRule>> {
        const requestOptions = await this.adminWorkflowLinkingRulesRetrieveRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LinkingRuleFromJSON(jsonValue));
    }

    /**
     * Event linking configuration for a definition.
     */
    async adminWorkflowLinkingRulesRetrieve(requestParameters: AdminWorkflowLinkingRulesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LinkingRule> {
        const response = await this.adminWorkflowLinkingRulesRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminWorkflowLinkingRulesUpdate without sending the request
     */
    async adminWorkflowLinkingRulesUpdateRequestOpts(requestParameters: AdminWorkflowLinkingRulesUpdateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminWorkflowLinkingRulesUpdate().'
            );
        }

        if (requestParameters['linkingRuleRequest'] == null) {
            throw new runtime.RequiredError(
                'linkingRuleRequest',
                'Required parameter "linkingRuleRequest" was null or undefined when calling adminWorkflowLinkingRulesUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/admin/workflow-linking-rules/{id}/`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: LinkingRuleRequestToJSON(requestParameters['linkingRuleRequest']),
        };
    }

    /**
     * Event linking configuration for a definition.
     */
    async adminWorkflowLinkingRulesUpdateRaw(requestParameters: AdminWorkflowLinkingRulesUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LinkingRule>> {
        const requestOptions = await this.adminWorkflowLinkingRulesUpdateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LinkingRuleFromJSON(jsonValue));
    }

    /**
     * Event linking configuration for a definition.
     */
    async adminWorkflowLinkingRulesUpdate(requestParameters: AdminWorkflowLinkingRulesUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LinkingRule> {
        const response = await this.adminWorkflowLinkingRulesUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminWorkflowTransitionActionsCreate without sending the request
     */
    async adminWorkflowTransitionActionsCreateRequestOpts(requestParameters: AdminWorkflowTransitionActionsCreateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['transitionActionWriteRequest'] == null) {
            throw new runtime.RequiredError(
                'transitionActionWriteRequest',
                'Required parameter "transitionActionWriteRequest" was null or undefined when calling adminWorkflowTransitionActionsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/admin/workflow-transition-actions/`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TransitionActionWriteRequestToJSON(requestParameters['transitionActionWriteRequest']),
        };
    }

    /**
     * Actions configured on a transition.
     */
    async adminWorkflowTransitionActionsCreateRaw(requestParameters: AdminWorkflowTransitionActionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TransitionActionWrite>> {
        const requestOptions = await this.adminWorkflowTransitionActionsCreateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TransitionActionWriteFromJSON(jsonValue));
    }

    /**
     * Actions configured on a transition.
     */
    async adminWorkflowTransitionActionsCreate(requestParameters: AdminWorkflowTransitionActionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TransitionActionWrite> {
        const response = await this.adminWorkflowTransitionActionsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminWorkflowTransitionActionsDestroy without sending the request
     */
    async adminWorkflowTransitionActionsDestroyRequestOpts(requestParameters: AdminWorkflowTransitionActionsDestroyRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminWorkflowTransitionActionsDestroy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/admin/workflow-transition-actions/{id}/`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Actions configured on a transition.
     */
    async adminWorkflowTransitionActionsDestroyRaw(requestParameters: AdminWorkflowTransitionActionsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.adminWorkflowTransitionActionsDestroyRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Actions configured on a transition.
     */
    async adminWorkflowTransitionActionsDestroy(requestParameters: AdminWorkflowTransitionActionsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.adminWorkflowTransitionActionsDestroyRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for adminWorkflowTransitionActionsList without sending the request
     */
    async adminWorkflowTransitionActionsListRequestOpts(requestParameters: AdminWorkflowTransitionActionsListRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/admin/workflow-transition-actions/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Actions configured on a transition.
     */
    async adminWorkflowTransitionActionsListRaw(requestParameters: AdminWorkflowTransitionActionsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<TransitionActionWrite>>> {
        const requestOptions = await this.adminWorkflowTransitionActionsListRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TransitionActionWriteFromJSON));
    }

    /**
     * Actions configured on a transition.
     */
    async adminWorkflowTransitionActionsList(requestParameters: AdminWorkflowTransitionActionsListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<TransitionActionWrite>> {
        const response = await this.adminWorkflowTransitionActionsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminWorkflowTransitionActionsPartialUpdate without sending the request
     */
    async adminWorkflowTransitionActionsPartialUpdateRequestOpts(requestParameters: AdminWorkflowTransitionActionsPartialUpdateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminWorkflowTransitionActionsPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/admin/workflow-transition-actions/{id}/`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedTransitionActionWriteRequestToJSON(requestParameters['patchedTransitionActionWriteRequest']),
        };
    }

    /**
     * Actions configured on a transition.
     */
    async adminWorkflowTransitionActionsPartialUpdateRaw(requestParameters: AdminWorkflowTransitionActionsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TransitionActionWrite>> {
        const requestOptions = await this.adminWorkflowTransitionActionsPartialUpdateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TransitionActionWriteFromJSON(jsonValue));
    }

    /**
     * Actions configured on a transition.
     */
    async adminWorkflowTransitionActionsPartialUpdate(requestParameters: AdminWorkflowTransitionActionsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TransitionActionWrite> {
        const response = await this.adminWorkflowTransitionActionsPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminWorkflowTransitionActionsReorderCreate without sending the request
     */
    async adminWorkflowTransitionActionsReorderCreateRequestOpts(requestParameters: AdminWorkflowTransitionActionsReorderCreateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['actionReorderRequest'] == null) {
            throw new runtime.RequiredError(
                'actionReorderRequest',
                'Required parameter "actionReorderRequest" was null or undefined when calling adminWorkflowTransitionActionsReorderCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/admin/workflow-transition-actions/reorder/`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ActionReorderRequestToJSON(requestParameters['actionReorderRequest']),
        };
    }

    /**
     * Assign positions 0..n-1 from the submitted order, in one transaction.
     */
    async adminWorkflowTransitionActionsReorderCreateRaw(requestParameters: AdminWorkflowTransitionActionsReorderCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ActionReorderResponse>> {
        const requestOptions = await this.adminWorkflowTransitionActionsReorderCreateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ActionReorderResponseFromJSON(jsonValue));
    }

    /**
     * Assign positions 0..n-1 from the submitted order, in one transaction.
     */
    async adminWorkflowTransitionActionsReorderCreate(requestParameters: AdminWorkflowTransitionActionsReorderCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ActionReorderResponse> {
        const response = await this.adminWorkflowTransitionActionsReorderCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminWorkflowTransitionActionsRetrieve without sending the request
     */
    async adminWorkflowTransitionActionsRetrieveRequestOpts(requestParameters: AdminWorkflowTransitionActionsRetrieveRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminWorkflowTransitionActionsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/admin/workflow-transition-actions/{id}/`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Actions configured on a transition.
     */
    async adminWorkflowTransitionActionsRetrieveRaw(requestParameters: AdminWorkflowTransitionActionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TransitionActionWrite>> {
        const requestOptions = await this.adminWorkflowTransitionActionsRetrieveRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TransitionActionWriteFromJSON(jsonValue));
    }

    /**
     * Actions configured on a transition.
     */
    async adminWorkflowTransitionActionsRetrieve(requestParameters: AdminWorkflowTransitionActionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TransitionActionWrite> {
        const response = await this.adminWorkflowTransitionActionsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminWorkflowTransitionActionsUpdate without sending the request
     */
    async adminWorkflowTransitionActionsUpdateRequestOpts(requestParameters: AdminWorkflowTransitionActionsUpdateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminWorkflowTransitionActionsUpdate().'
            );
        }

        if (requestParameters['transitionActionWriteRequest'] == null) {
            throw new runtime.RequiredError(
                'transitionActionWriteRequest',
                'Required parameter "transitionActionWriteRequest" was null or undefined when calling adminWorkflowTransitionActionsUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/admin/workflow-transition-actions/{id}/`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: TransitionActionWriteRequestToJSON(requestParameters['transitionActionWriteRequest']),
        };
    }

    /**
     * Actions configured on a transition.
     */
    async adminWorkflowTransitionActionsUpdateRaw(requestParameters: AdminWorkflowTransitionActionsUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TransitionActionWrite>> {
        const requestOptions = await this.adminWorkflowTransitionActionsUpdateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TransitionActionWriteFromJSON(jsonValue));
    }

    /**
     * Actions configured on a transition.
     */
    async adminWorkflowTransitionActionsUpdate(requestParameters: AdminWorkflowTransitionActionsUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TransitionActionWrite> {
        const response = await this.adminWorkflowTransitionActionsUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminWorkflowTransitionsCreate without sending the request
     */
    async adminWorkflowTransitionsCreateRequestOpts(requestParameters: AdminWorkflowTransitionsCreateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['transitionWriteRequest'] == null) {
            throw new runtime.RequiredError(
                'transitionWriteRequest',
                'Required parameter "transitionWriteRequest" was null or undefined when calling adminWorkflowTransitionsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/admin/workflow-transitions/`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TransitionWriteRequestToJSON(requestParameters['transitionWriteRequest']),
        };
    }

    /**
     * Transitions of a definition.
     */
    async adminWorkflowTransitionsCreateRaw(requestParameters: AdminWorkflowTransitionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TransitionWrite>> {
        const requestOptions = await this.adminWorkflowTransitionsCreateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TransitionWriteFromJSON(jsonValue));
    }

    /**
     * Transitions of a definition.
     */
    async adminWorkflowTransitionsCreate(requestParameters: AdminWorkflowTransitionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TransitionWrite> {
        const response = await this.adminWorkflowTransitionsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminWorkflowTransitionsDestroy without sending the request
     */
    async adminWorkflowTransitionsDestroyRequestOpts(requestParameters: AdminWorkflowTransitionsDestroyRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminWorkflowTransitionsDestroy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/admin/workflow-transitions/{id}/`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Transitions of a definition.
     */
    async adminWorkflowTransitionsDestroyRaw(requestParameters: AdminWorkflowTransitionsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.adminWorkflowTransitionsDestroyRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Transitions of a definition.
     */
    async adminWorkflowTransitionsDestroy(requestParameters: AdminWorkflowTransitionsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.adminWorkflowTransitionsDestroyRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for adminWorkflowTransitionsList without sending the request
     */
    async adminWorkflowTransitionsListRequestOpts(requestParameters: AdminWorkflowTransitionsListRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/admin/workflow-transitions/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Transitions of a definition.
     */
    async adminWorkflowTransitionsListRaw(requestParameters: AdminWorkflowTransitionsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<TransitionWrite>>> {
        const requestOptions = await this.adminWorkflowTransitionsListRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TransitionWriteFromJSON));
    }

    /**
     * Transitions of a definition.
     */
    async adminWorkflowTransitionsList(requestParameters: AdminWorkflowTransitionsListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<TransitionWrite>> {
        const response = await this.adminWorkflowTransitionsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminWorkflowTransitionsPartialUpdate without sending the request
     */
    async adminWorkflowTransitionsPartialUpdateRequestOpts(requestParameters: AdminWorkflowTransitionsPartialUpdateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminWorkflowTransitionsPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/admin/workflow-transitions/{id}/`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedTransitionWriteRequestToJSON(requestParameters['patchedTransitionWriteRequest']),
        };
    }

    /**
     * Transitions of a definition.
     */
    async adminWorkflowTransitionsPartialUpdateRaw(requestParameters: AdminWorkflowTransitionsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TransitionWrite>> {
        const requestOptions = await this.adminWorkflowTransitionsPartialUpdateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TransitionWriteFromJSON(jsonValue));
    }

    /**
     * Transitions of a definition.
     */
    async adminWorkflowTransitionsPartialUpdate(requestParameters: AdminWorkflowTransitionsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TransitionWrite> {
        const response = await this.adminWorkflowTransitionsPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminWorkflowTransitionsRetrieve without sending the request
     */
    async adminWorkflowTransitionsRetrieveRequestOpts(requestParameters: AdminWorkflowTransitionsRetrieveRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminWorkflowTransitionsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/admin/workflow-transitions/{id}/`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Transitions of a definition.
     */
    async adminWorkflowTransitionsRetrieveRaw(requestParameters: AdminWorkflowTransitionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TransitionWrite>> {
        const requestOptions = await this.adminWorkflowTransitionsRetrieveRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TransitionWriteFromJSON(jsonValue));
    }

    /**
     * Transitions of a definition.
     */
    async adminWorkflowTransitionsRetrieve(requestParameters: AdminWorkflowTransitionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TransitionWrite> {
        const response = await this.adminWorkflowTransitionsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminWorkflowTransitionsUpdate without sending the request
     */
    async adminWorkflowTransitionsUpdateRequestOpts(requestParameters: AdminWorkflowTransitionsUpdateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminWorkflowTransitionsUpdate().'
            );
        }

        if (requestParameters['transitionWriteRequest'] == null) {
            throw new runtime.RequiredError(
                'transitionWriteRequest',
                'Required parameter "transitionWriteRequest" was null or undefined when calling adminWorkflowTransitionsUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/admin/workflow-transitions/{id}/`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: TransitionWriteRequestToJSON(requestParameters['transitionWriteRequest']),
        };
    }

    /**
     * Transitions of a definition.
     */
    async adminWorkflowTransitionsUpdateRaw(requestParameters: AdminWorkflowTransitionsUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TransitionWrite>> {
        const requestOptions = await this.adminWorkflowTransitionsUpdateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TransitionWriteFromJSON(jsonValue));
    }

    /**
     * Transitions of a definition.
     */
    async adminWorkflowTransitionsUpdate(requestParameters: AdminWorkflowTransitionsUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TransitionWrite> {
        const response = await this.adminWorkflowTransitionsUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
